export default __webpack_public_path__ + "static/media/aysam-new.e5ccd1bf.png";